import React, { useMemo } from 'react';

import FeaturedCard from '@/pages/home/hero/thailand/FeaturedCard';
import { cdnBonusImg, cdnImage } from '@/utils/image-utils';
import { BonusRedeemType } from '@lucky7ventures/bff-types';
import { useSelector } from 'react-redux';
import { selectAvailableBonuses } from '@/store/selectors/bonusesSelectors';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { useCashierShow } from '@/features/cashier/useCashier';
import { useRewardsWheel } from '@/hooks/useRewardsWheel';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { useIntl } from 'react-intl';

const FeaturedCenter = () => {
  const availableBonuses = useSelector(selectAvailableBonuses);
  const showCashier = useCashierShow();
  const { isEnabled: isWheelEnabled, pagePath } = useRewardsWheel();
  const navigate = useAbsoluteNavigate();
  const intl = useIntl();

  const openCashierWithBonusHandler = (promoCode: string) => {
    triggerGTag(GTagEvents.home_hero_bonus_click, { bonusCode: promoCode });
    showCashier({ bonusCode: promoCode });
  };

  const openWheel = () => {
    triggerGTag(GTagEvents.home_hero_wheel_click);
    navigate(`/${pagePath}`);
  };

  const bonus = useMemo(() => {
    return availableBonuses.find(
      bonus =>
        bonus.redeemTypeId === BonusRedeemType.Deposit ||
        bonus.redeemTypeId === BonusRedeemType.DepositBonusCode,
    );
  }, [availableBonuses]);

  return (
    <div className="flex flex-row lg:flex-col justify-center gap-4">
      {isWheelEnabled && (
        <FeaturedCard
          onClickCallback={openWheel}
          title={intl.formatMessage({ id: 'rewardReel.title' })}
          imgUrl={cdnImage('rewards-wheel/rewards-wheel.png', {
            width: '120',
            height: 'auto',
            fit: 'contain',
            dpr: '2',
          })}
        />
      )}
      {bonus && (
        <FeaturedCard
          onClickCallback={() => {
            openCashierWithBonusHandler(bonus.promoCode);
          }}
          title={bonus.name}
          imgUrl={cdnBonusImg(bonus.image, {
            width: '120',
            height: 'auto',
            fit: 'contain',
            dpr: '2',
          })}
        />
      )}
    </div>
  );
};

export default FeaturedCenter;
